import Points from './components/Points';
export default Points;